export enum MergeCompareMessages {
    LIMIT_EXCEEDED = "Превышен лимит: в сравнении может быть не более 10 объявлений. Удалите лишние или уменьшите очередь.",
    MERGE_SUCCESS = "Объявления успешно добавлены к сравнению.",
    MERGE_ERROR = "Не удалось объединить объявления.",
    BUTTON_TEXT = "Добавить очередь в сравнение"
}

export const MESSAGE_AUTO_CLOSE = 3000;